import { apiInstanceFetch } from "../../../util/api";
import * as ActionType from "./transaction.type";

// Get transactions with pagination and filters
export const getTransactions = (page, limit, type, status, startDate, endDate, search) => (dispatch) => {
  let url = `transaction/?page=${page}&limit=${limit}`;
  if (type && type !== "all") url += `&type=${type}`;
  if (status && status !== "all") url += `&status=${status}`;
  if (startDate && startDate !== "All") url += `&startDate=${startDate}`;
  if (endDate && endDate !== "All") url += `&endDate=${endDate}`;
  if (search && search.trim() !== "") url += `&search=${search}`;

  apiInstanceFetch
    .get(url)
    .then((res) => {
      dispatch({
        type: ActionType.GET_TRANSACTIONS,
        payload: {
          transactions: res.transactions,
          pagination: res.pagination,
        },
      });
    })
    .catch((error) => console.error(error));
};

// Get live feed for dashboard
export const getLiveFeed = (limit = 20) => (dispatch) => {
  apiInstanceFetch
    .get(`transaction/liveFeed?limit=${limit}`)
    .then((res) => {
      dispatch({
        type: ActionType.GET_LIVE_FEED,
        payload: res.transactions,
      });
    })
    .catch((error) => console.error(error));
};

// Get transaction stats
export const getTransactionStats = (startDate, endDate) => (dispatch) => {
  let url = `transaction/stats?`;
  if (startDate && startDate !== "All") url += `startDate=${startDate}&`;
  if (endDate && endDate !== "All") url += `endDate=${endDate}`;

  apiInstanceFetch
    .get(url)
    .then((res) => {
      dispatch({
        type: ActionType.GET_TRANSACTION_STATS,
        payload: res.stats,
      });
    })
    .catch((error) => console.error(error));
};

// Add new transaction from socket (real-time)
export const addNewTransaction = (transaction) => (dispatch) => {
  dispatch({
    type: ActionType.NEW_TRANSACTION,
    payload: transaction,
  });
};
